var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { AiUpperCaseIconGlyph } from '@shapeable/icons';
// import { CopperAiDescription } from '../../data';
import { classNames } from '@shapeable/utils';
import { IconTextValue } from './icon-text-value';
import { ContentNode } from '../entities/content-node';
import { useEntity } from '../hooks/use-entity';
import { useLang } from '../hooks/use-lang';
var cls = classNames('gpt-button');
export var GptButtonDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n    cursor: pointer;\n  "], ["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n    cursor: pointer;\n  "])), theme.UNIT(5))
});
var CopperAiPillStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-radius: 100px;\n    font-size: 0.9em;\n    font-weight: 600;\n    min-width: 160px;\n    padding: ", " ", " ", " ", ";\n    background-color: ", ";\n    ", ";\n    &:hover {\n      border-color: ", ";\n      ", ";\n      color: ", ";\n    }\n  "], ["\n    border-radius: 100px;\n    font-size: 0.9em;\n    font-weight: 600;\n    min-width: 160px;\n    padding: ", " ", " ", " ", ";\n    background-color: ", ";\n    ", ";\n    &:hover {\n      border-color: ", ";\n      ", ";\n      color: ", ";\n    }\n  "])), theme.UNIT(2), theme.UNIT(6), theme.UNIT(2), theme.UNIT(2), theme.COLOR('app-chrome'), theme.TRANSITION('border-color', 'color'), theme.COLOR('primary'), theme.FILL('button-hover'), theme.COLOR('button-hover')),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-weight: 300;\n    font-size: 0.8em;\n  "], ["\n    font-weight: 300;\n    font-size: 0.8em;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  GptPill: styled(IconTextValue)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), CopperAiPillStyles),
  Description: styled(ContentNode)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
export var GptButton = function (props) {
  var className = props.className,
    children = props.children,
    description = props.description,
    href = props.href,
    label = props.label,
    icon = props.icon;
  var entity = useEntity(props.entity);
  var Icon = icon || AiUpperCaseIconGlyph;
  var t = useLang();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.GptPill, {
    href: href,
    iconSize: 55,
    iconComponent: Icon
  }, t(label)), React.createElement(My.Description, {
    entity: description
  }), children);
};
GptButton.defaultProps = GptButtonDefaultProps;
GptButton.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;